import { Component, OnInit, HostListener, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../service/auth.service';
import { CustomValidatorsService } from '../service/custom-validators.service';
import { EventService } from '../service/event.service';
import { DatePipe } from '@angular/common';
import { AF_CONSTANTS, AfPcDomain, RadioGroupButtonModel } from '../model/af.model';
import { ValidateAndNavigateEvent, BeforeSubmitErrorEvent, ProgressBarEvent, ChangeNavigationEvent, SkipToMainContentEvent, ShowProgressEvent, ShowErrorEvent } from '../service/events';
import { PoliticalContributionService } from '../service/political-contribution.service';
import { BaseComponent } from '../base-component';
import { Router } from '@angular/router';
import { MatRadioChange } from '@angular/material/radio';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-pc-mbam',
    templateUrl: './pc-mbam.component.html',
    styleUrls: ['./pc-mbam.component.scss'],
    standalone: false
})
export class PcMbamComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  mbamSurveyForm: UntypedFormGroup;
  mbamSurveyData: AfPcDomain;
  contributionListChange: boolean = false;
  signatureImg: string; //for @Input wet-signature
  sigCheckValue: boolean = false;
  date: any;
  check: boolean = false;
  checkRadio: boolean = false;
  blueBorder: boolean = false;
  redBorder: boolean = false;
  hasBeenSubmittted: boolean = false;
  radioButtonGroupData: RadioGroupButtonModel[] = [];
  showRadioOutsideEmployment: boolean = false;
  showMemberCompany: boolean = false;
  showElectedOfficial: boolean = false;
  showMemberCommitee: boolean = false;
  showContribution: boolean = false;

  @ViewChild("addElement") addElement: ElementRef;
  @ViewChild("addButtonElement") addButtonElement: ElementRef;

  // Regex to match Server Validations
  regexName: RegExp = /^[A-Za-z\u00C0-\u017F\-',. ]+$/;

  constructor(private readonly fb: UntypedFormBuilder, private readonly userService: AuthService, private readonly customValidator: CustomValidatorsService,
    private readonly datepipe: DatePipe, private readonly eventBus: EventService, private readonly politicalService: PoliticalContributionService,
    private readonly _router: Router, private readonly _snackBar: MatSnackBar) {
    super(eventBus, _router);
  }

  ngOnInit() {
    this.createGroup();
    this.subscribeEvents();
  }

  ngAfterViewInit() {

    this.mbamSurveyForm.valueChanges.subscribe(() => {
      setTimeout(() => {
        let progress = this.getPercentage(this.mbamSurveyForm);
        this.eventBus.emit(new ProgressBarEvent({ id: progress }));
      }, 100);
    });

    this.contribution.valueChanges.subscribe(() => {
      this.setValidators(this.mbamSurveyForm);
    });

    this.pcMbamAccepted.valueChanges.subscribe(() => {
      this.setDate();
    });

    // retain navigation on page refresh
    let navlink = this.userService.getNavLinks().find(e => e.routerLink === "/pc-mbam");
    this.eventBus.emit(new ChangeNavigationEvent({ id: navlink.id }));

    this.handleZoom();
  }

  get submit() { return this.mbamSurveyForm.get('submit') }
  get bookmarkUrl() { return this.mbamSurveyForm.get('bookmarkUrl') };
  get verifyId() { return this.mbamSurveyForm.get('verifyId') }
  get contribution() { return this.mbamSurveyForm.get('contribution') }
  get mbamOutsideEmployment() { return this.mbamSurveyForm.get('mbamOutsideEmployment') }
  get mbamMemberCompany() { return this.mbamSurveyForm.get('mbamMemberCompany') }
  get mbamElectedOfficial() { return this.mbamSurveyForm.get('mbamElectedOfficial') }
  get mbamMemberCommitee() { return this.mbamSurveyForm.get('mbamMemberCommitee') }
  get mbamComment() { return this.mbamSurveyForm.get('mbamComment') }
  get pcMbamSignature() { return this.mbamSurveyForm.get('pcMbamSignature') }
  get pcMbamSignedName() { return this.mbamSurveyForm.get('pcMbamSignedName') }
  get pcGroup() { return this.mbamSurveyForm.get('pcGroup') }
  get pcMbamAccepted() { return this.mbamSurveyForm.get('pcMbamAccepted') }
  get pcMbamWetSignatureDate() { return this.mbamSurveyForm.get('pcMbamWetSignatureDate') }
  get pcCandidateList() { return this.mbamSurveyForm.get('pcCandidateList') as UntypedFormArray; }

  subscribeEvents() {
    this.politicalService.getPcMbam().subscribe({
      next: (data: AfPcDomain) => {
        this.mbamSurveyData = data;
        this.mbamSurveyForm.patchValue(data);
        this.setValidators(this.mbamSurveyForm);

        this.signatureImg = data.pcMbamSignature;
        this.date = data.pcMbamWetSignatureDate;

        for (let afPcDetail of this.mbamSurveyData.pcCandidateList) {
          let fg: UntypedFormGroup = this.fieldsGroup();
          fg.patchValue(afPcDetail);
          this.pcCandidateList.push(fg);
        }

        this.blueBorder = false;

        /*
           radio button meta data
         */
        //showOutsideEmployment
        let radioGroupMetaData = new RadioGroupButtonModel();
        radioGroupMetaData.groupName = "radioOutsideEmployment";
        radioGroupMetaData.groupValue = data.mbamOutsideEmployment;
        this.radioButtonGroupData.push(radioGroupMetaData);

        //showMemberCompany
        radioGroupMetaData.groupName = "radioMemberCompany";
        radioGroupMetaData.groupValue = data.mbamMemberCompany;
        this.radioButtonGroupData.push(radioGroupMetaData);

        //showElectedOfficial
        radioGroupMetaData.groupName = "radioElectedOfficial";
        radioGroupMetaData.groupValue = data.mbamElectedOfficial;
        this.radioButtonGroupData.push(radioGroupMetaData);

        //showMemberCommitee
        radioGroupMetaData.groupName = "radioMemberCommitee";
        radioGroupMetaData.groupValue = data.mbamMemberCommitee;
        this.radioButtonGroupData.push(radioGroupMetaData);

        //showContribution
        radioGroupMetaData.groupName = "radioContribution";
        radioGroupMetaData.groupValue = data.contribution;
        this.radioButtonGroupData.push(radioGroupMetaData);
      }
    });

    this.sub = this.eventBus.on(
      ValidateAndNavigateEvent,
      (event): void => {
        this.bookmarkUrl.setValue("");
        if (event.payload.currentLink === '/pc-mbam') {
          this.bookmarkUrl.setValue("");
          this.verifyId.setValue(this.userService.getVerifyId());
          if (event.payload.save) {
            this.submitPcMbam((this.mbamSurveyForm.value), event);
          } else if (event.payload.saveAndFinishLater) {
            this.bookmarkUrl.setValue(event.payload.currentLink);
            this.submitPcMbam((this.mbamSurveyForm.value), event);
          } else {
            let hasContribution: boolean = this.hasContribution();
            if (hasContribution) {
              if (this.pcCandidateList.length > 0) {
                this.pcCandidateList.markAllAsTouched();
              } else {
                this.createContribution('');
                this.focusTarget();
              }
              this.eventBus.emit(new ShowProgressEvent({ show: false }));
              this.eventBus.emit(new ShowErrorEvent({ httpStatus: 500, text: 'At least one Contribution is Required.' }));
            } else if (this.validate()) {
              this.submitPcMbam((this.mbamSurveyForm.value), event);
            } else {
              this.eventBus.emit(new BeforeSubmitErrorEvent({}));
            }
          }
        }
      }
    );

    this.eventBus.on(
      SkipToMainContentEvent,
      (event): void => {
        if (event.payload.text && event.payload.text == "/pc-mbam") {
          let mainContentElement = document.querySelector("#main-content"); //check if main-content id exists on page
          if (mainContentElement) {
            mainContentElement.scrollIntoView(true);
          }
        }
      }
    );

    this.eventBus.emit(new ProgressBarEvent({ id: 0 }));

  }

  onFocusOutMainContent(event) {
    this.eventBus.emit(new SkipToMainContentEvent({ text: "FocusOff" }));
  }

  createGroup() {
    this.mbamSurveyForm = this.fb.group({
      submit: [false],
      verifyId: [],
      bookmarkUrl: [''],
      contribution: ['', Validators.required],

      //radio buttons null '1' or '0'
      mbamOutsideEmployment: ['', [Validators.required]],
      mbamMemberCompany: ['', [Validators.required]],
      mbamElectedOfficial: ['', [Validators.required]],
      mbamMemberCommitee: ['', [Validators.required]],

      //comment if any radio buttons yes
      mbamComment: [''],

      //wet signature
      pcMbamSignature: ['', Validators.required],
      pcMbamSignedName: ['', [Validators.required, Validators.maxLength(250), this.customValidator.validateRequiredField, Validators.pattern(this.regexName)]],
      pcGroup: ['', [Validators.required, Validators.maxLength(250), this.customValidator.validateRequiredField]],
      pcMbamWetSignatureDate: [''],
      pcMbamAccepted: ['', [Validators.requiredTrue]],

      //donations
      pcCandidateList: new UntypedFormArray([])
    });
  }

  fieldsGroup(): UntypedFormGroup {
    return this.fb.group({
      contributionDate: ['', [Validators.required, Validators.maxLength(100)]],
      recipientName: ['', [Validators.required, this.customValidator.validateRequiredField]],
      officeRunning: ['', [Validators.required, this.customValidator.validateRequiredField]],
      amount: ['', [Validators.required, this.customValidator.validateRequiredField]],
      address: ['', [Validators.required, this.customValidator.validateRequiredField]]
    });
  }

  createContribution(check: string) {
    let fg: UntypedFormGroup = this.fieldsGroup();
    this.pcCandidateList.push(fg);
    setTimeout(() => {
      if (check == 'click') {
        this.addElement.nativeElement.focus();
      }
      this.blueBorder = true;
    }, 0);
  }

  deleteClick(i) {
    this.pcCandidateList.removeAt(i);
    setTimeout(() => {
      if (this.pcCandidateList && this.pcCandidateList.length == 0) {
        this.addButtonElement.nativeElement.focus();
        this.blueBorder = false;
      } else {
        this.addElement.nativeElement.focus();
        this.blueBorder = true;
      }
    }, 0);
  }

  getUrl(sig: string) {
    this.signatureImg = sig; // Gets the base64 String from wet-signature @Output
    this.mbamSurveyForm.get('pcMbamSignature').setValue(sig);
  }

  sigCheck(sigCheck: boolean) {
    this.sigCheckValue = sigCheck;
  }

  setDate() {
    if (this.pcMbamAccepted.value) {
      if (!this.date) {
        if (!this.mbamSurveyData.pcMbamWetSignatureDate) {
          this.date = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss');
        }
      }
    } else if (!this.mbamSurveyData.pcMbamWetSignatureDate) {
      this.date = null;
    }
  }

  getPercentage(politicalContributionGroup: UntypedFormGroup): number {

    if (this.contribution.value === '0') {
      return 100;
    }

    let container: UntypedFormGroup = politicalContributionGroup;
    let errorCount = 0;
    let totalCount = 0;

    for (let controlKey in container.controls) {
      if (container.controls.hasOwnProperty(controlKey)) {
        if (container.controls[controlKey].validator != null) {
          totalCount += container.controls[controlKey].validator.length;
        }
        if (container.controls[controlKey].errors) {
          errorCount += Object.keys(container.controls[controlKey].errors).length;
        }
      }
    }

    for (let container of politicalContributionGroup.get('pcCandidateList')['controls']) {
      for (let controlKey in container.controls) {
        if (container.controls.hasOwnProperty(controlKey)) {
          if (container.controls[controlKey].validator != null) {
            totalCount += container.controls[controlKey].validator.length;
          }
          if (container.controls[controlKey].errors) {
            errorCount += Object.keys(container.controls[controlKey].errors).length;
          }
        }
      }
    }

    let percentage = ((totalCount - errorCount) / totalCount) * 100;
    return percentage;

  }

  focusTarget() {
    setTimeout(() => {
      this.addElement.nativeElement.focus();
      this.redBorder = true;
    });
  }

  hasContribution(): boolean {
    let indicatedContribution: boolean = (this.contribution.value == 1);

    let contributionList: boolean = false;
    if (this.pcCandidateList.length > 0 && this.pcCandidateList.valid) {
      contributionList = true;
    }

    return (indicatedContribution && !contributionList);
  }

  validate() {

    if (this.contribution.value == 0) {
      return true;
    }

    if (!this.pcMbamSignature.value) {
      this.pcMbamSignature.setErrors({ invalid: true });
    }

    if (!this.pcMbamAccepted.value) {
      this.pcMbamAccepted.setErrors({ invalid: true });
      this.check = true;
    }

    this.submit.setValue(true);
    this.hasBeenSubmittted = true;
    this.mbamSurveyForm.markAllAsTouched();
    return !this.mbamSurveyForm.invalid;
  }

  submitPcMbam(afPcDomain: AfPcDomain, event) {
    this.politicalService.savePcMbam(afPcDomain).subscribe({
      next: () => {
        if (event.payload.save) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
        } else if (event.payload.saveAndFinishLater) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
          this._router.navigate(['sessionTimedOut']);
        } else {
          this.eventBus.emit(new ChangeNavigationEvent({ id: event.payload.id }));
          this._router.navigateByUrl(event.payload.nextNavLink);
        }
      },
      error: (error: any) => console.log(error)
    });
  }

  confirmOnBlur() {
    if (this.pcMbamAccepted.value) {
      this.check = false;
    } else {
      this.check = true;
    }
  }

  confirmOnFocus() {
    this.check = false;
  }

  radioOnChange(event: MatRadioChange) {
    const radioGroupName = event.source.name;
    const radioGroupChgValue = event.value;
    if (this.radioButtonGroupData) {
      for (let radioGroup of this.radioButtonGroupData) {
        if (radioGroup.groupName == radioGroupName) {
          radioGroup.groupValue = radioGroupChgValue;
          break;
        }
      }
    }
  }

  radioOnFocusOut(event: any) {
    const radioGroupName = event.target.name;
    let showError: boolean = false;
    if (this.radioButtonGroupData) {
      for (let radioGroup of this.radioButtonGroupData) {
        if (radioGroup.groupName == radioGroupName) {
          if (radioGroup.groupValue != "0" && radioGroup.groupValue != "1") {
            showError = true;
          }
          if (radioGroup.groupName == "radioOutsideEmployment") {
            this.showRadioOutsideEmployment = showError;
          }
          else if (radioGroup.groupName == "radioMemberCompany") {
            this.showMemberCompany = showError;
          }
          else if (radioGroup.groupName == "radioElectedOfficial") {
            this.showElectedOfficial = showError;
          }
          else if (radioGroup.groupName == "radioMemberCommitee") {
            this.showMemberCommitee = showError;
          }
          else if (radioGroup.groupName == "radioContribution") {
            this.showContribution = showError;
          }
          break;
        }
      }
    }
  }

  radioOnFocus(event: any) {
    const radioGroupName = event.target.name;

    if (radioGroupName == "radioOutsideEmployment") {
      this.showRadioOutsideEmployment = false;
    }
    else if (radioGroupName == "radioMemberCompany") {
      this.showMemberCompany = false;
    }
    else if (radioGroupName == "radioElectedOfficial") {
      this.showElectedOfficial = false;
    }
    else if (radioGroupName == "radioMemberCommitee") {
      this.showMemberCommitee = false;
    }
    else if (radioGroupName == "radioContribution") {
      this.showContribution = false;
    }
  }

  setValidators(control: UntypedFormGroup) {

    const optOut = control.get('contribution');

    const mbamOutsideEmployment = control.get('mbamOutsideEmployment');
    const mbamMemberCompany = control.get('mbamMemberCompany');
    const mbamElectedOfficial = control.get('mbamElectedOfficial');
    const mbamMemberCommitee = control.get('mbamMemberCommitee');
    const mbamComment = control.get('mbamComment');

    const pcMbamSignedName = control.get('pcMbamSignedName');
    const pcGroup = control.get('pcGroup');
    const pcMbamAccepted = control.get('pcMbamAccepted');

    //entire form with optOut
    if (optOut.value && optOut.value === '1') {//yes
      mbamOutsideEmployment.setValidators([Validators.required]);
      mbamMemberCompany.setValidators([Validators.required]);
      mbamElectedOfficial.setValidators([Validators.required]);
      mbamMemberCommitee.setValidators([Validators.required]);
      pcGroup.setValidators([Validators.required, Validators.maxLength(250)]);
      pcMbamAccepted.setValidators([Validators.requiredTrue]);
    } else {//no or null
      mbamOutsideEmployment.setValidators(null);
      mbamOutsideEmployment.setErrors(null);
      mbamMemberCompany.setValidators(null);
      mbamMemberCompany.setErrors(null);
      mbamElectedOfficial.setValidators(null);
      mbamElectedOfficial.setErrors(null);
      mbamMemberCommitee.setValidators(null);
      mbamMemberCommitee.setErrors(null);
      pcMbamSignedName.setValidators(null);
      pcMbamSignedName.setErrors(null);
      pcGroup.setValidators(null);
      pcGroup.setErrors(null);
      pcMbamAccepted.setValidators(null);
      pcMbamAccepted.setErrors(null);
    }

    mbamOutsideEmployment.updateValueAndValidity();
    mbamMemberCompany.updateValueAndValidity();
    mbamElectedOfficial.updateValueAndValidity();
    mbamMemberCommitee.updateValueAndValidity();
    mbamComment.updateValueAndValidity();
    pcMbamSignedName.updateValueAndValidity();
    pcGroup.updateValueAndValidity();
    pcMbamAccepted.updateValueAndValidity();

    //comment
    let commentReq: boolean = mbamOutsideEmployment.value === '1' || mbamMemberCompany.value === '1'
      || mbamElectedOfficial.value === '1' || mbamMemberCommitee.value === '1';

    this.setComment(commentReq, optOut.value, mbamComment);

  }

  setComment(commentReq: boolean, optOutValue: string, mbamComment: AbstractControl) {

    if (commentReq && optOutValue === '1') {
      mbamComment.setValidators([Validators.required]);
    } else {
      mbamComment.setValidators(null);
      mbamComment.setErrors(null);
    }

    mbamComment.updateValueAndValidity();
  }

  @HostListener('window:resize', ['$event'])
  @HostListener('window:load', ['$event'])
  handleZoom() {
    const windowWidth = window.innerWidth;
    if (windowWidth <= AF_CONSTANTS.windowWidth) {
      this.contributionListChange = true;
    } else {
      this.contributionListChange = false;
    }
  }

  @HostListener('document:keydown', ['$event'])
  clearBorder(keyDown: KeyboardEvent) {
    if (keyDown.key === 'Tab') {
      this.blueBorder = false;
      this.redBorder = false;
    }
  }

  @HostListener('click', ['$event'])
  clearBorderClick() {
    this.blueBorder = false;
    this.redBorder = false;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
